import axios from "axios";
import { API_URL } from "../variables";

export const FETCH_ALL_PRODUCTS_REQUEST = "FETCH_ALL_PRODUCTS_REQUEST";
export const FETCH_ALL_PRODUCTS_SUCCESS = "FETCH_ALL_PRODUCTS_SUCCESS";
export const FETCH_ALL_PRODUCTS_FAILURE = "FETCH_ALL_PRODUCTS_FAILURE";

export const FETCH_PRODUCTS_REQUEST = "FETCH_PRODUCTS_REQUEST";
export const FETCH_PRODUCTS_SUCCESS = "FETCH_PRODUCTS_SUCCESS";
export const FETCH_PRODUCTS_FAILURE = "FETCH_PRODUCTS_FAILURE";

export const FETCH_PRODUCT_BY_ID_REQUEST = "FETCH_PRODUCT_BY_ID_REQUEST";
export const FETCH_PRODUCT_BY_ID_SUCCESS = "FETCH_PRODUCT_BY_ID_SUCCESS";
export const FETCH_PRODUCT_BY_ID_FAILURE = "FETCH_PRODUCT_BY_ID_FAILURE";

export const FETCH_PRODUCTS_BY_CATEGORY_REQUEST =
  "FETCH_PRODUCTS_BY_CATEGORY_REQUEST";
export const FETCH_PRODUCTS_BY_CATEGORY_SUCCESS =
  "FETCH_PRODUCTS_BY_CATEGORY_SUCCESS";
export const FETCH_PRODUCTS_BY_CATEGORY_FAILURE =
  "FETCH_PRODUCTS_BY_CATEGORY_FAILURE";

export const fetchAllProducts =
  (pagination = 10000, sortBy = "") =>
  async (dispatch) => {
    dispatch({ type: FETCH_ALL_PRODUCTS_REQUEST });
    try {
      const url = `${API_URL}/api/products?page=1`;
      const response = await axios.post(url, {
        pagination,
        sortBy,
        status: "published",
      });
      dispatch({
        type: FETCH_ALL_PRODUCTS_SUCCESS,
        payload: {
          results: response.data.results,
          next: response.data.next,
          previous: response.data.previous,
          count: response.data.count,
        },
      });
    } catch (error) {
      dispatch({ type: FETCH_ALL_PRODUCTS_FAILURE, payload: error.message });
    }
  };

export const fetchAllProductsWithSearch =
  (page = 1, pagination = 24, search = "", sortBy = "created_at") =>
  async (dispatch) => {
    dispatch({ type: FETCH_PRODUCTS_REQUEST });
    try {
      const url = `${API_URL}/api/products?page=${page}`;
      const response = await axios.post(url, {
        pagination,
        search,
        sortBy,
        status: "published",
        scope: "light",
      });
      dispatch({
        type: FETCH_PRODUCTS_SUCCESS,
        payload: {
          results: response.data.results,
          next: response.data.next,
          previous: response.data.previous,
          count: response.data.count,
        },
      });
    } catch (error) {
      dispatch({ type: FETCH_PRODUCTS_FAILURE, payload: error.message });
    }
  };

export const fetchProducts =
  (page = 1, pagination = 30, sortBy = "") =>
  async (dispatch) => {
    dispatch({ type: FETCH_PRODUCTS_REQUEST });
    try {
      const url = `${API_URL}/api/products?page=${page}`;
      const response = await axios.post(url, {
        pagination,
        sortBy,
        status: "published",
      });
      dispatch({
        type: FETCH_PRODUCTS_SUCCESS,
        payload: {
          results: response.data.results,
          next: response.data.next,
          previous: response.data.previous,
          count: response.data.count,
        },
      });
    } catch (error) {
      dispatch({ type: FETCH_PRODUCTS_FAILURE, payload: error.message });
    }
  };

export const fetchProductById = (id) => async (dispatch) => {
  dispatch({ type: FETCH_PRODUCT_BY_ID_REQUEST });
  try {
    const response = await axios.get(`${API_URL}/api/products/${id}`);
    dispatch({ type: FETCH_PRODUCT_BY_ID_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_PRODUCT_BY_ID_FAILURE, payload: error.message });
  }
};

export const fetchProductsByCategory = (categoryId) => async (dispatch) => {
  dispatch({ type: FETCH_PRODUCTS_REQUEST });
  try {
    const response = await axios.get(
      `${API_URL}/api/products/category/${categoryId}`
    );
    dispatch({ type: FETCH_PRODUCTS_SUCCESS, payload: response.data.results });
  } catch (error) {
    dispatch({ type: FETCH_PRODUCTS_FAILURE, payload: error.message });
  }
};
